import _ from 'lodash'

// Notifications
export const addNotification = action('ADD_NOTIFICATION')
export const removeNotification = action('REMOVE_NOTIFICATION')
export const showNotifications = action('SHOW_ERROR_NOTIFICATIONS')
export const clearAllNotifications = action('CLEAR_ALL_NOTIFICATIONS')

// Config
const actionMap = { 'api': setAPI,
                    'ui': setUI,
                    'notices': addNotification }

export const setConfig = opts => {
  _.forEach(opts, (v, k) => {
    actionMap[k](v)
  })
}
export const mergeConfig = action('MERGE_CONFIG')

// Skins
export const setInterface = action('SET_SKINS')

// workflows
// export const setWorkflow = action('SET_WORKFLOW')
export const addWorkflow = action('ADD_WORKFLOW')
export const updateWorkflow = action('UPDATE_WORKFLOW')
// export const removeWorkflow = action('REMOVE_WORKFLOW')
// export const clearWorkflow = action('CLEAR_WORKFLOW')

// fragments
export const addFragment = action('ADD_FRAGMENT')
export const removeFragment = action('REMOVE_FRAGMENT')
export const clearFragment = action('CLEAR_FRAGMENT')

// UI
export const setUI = action('SET_USER_INTERFACE')
export const mergeUI = action('MERGE_USER_INTERFACE')
export const addUI = action('ADD_USER_INTERFACE')

// Form
export const addForm = action('ADD_FORM')
export const removeForm = action('REMOVE_FORM')
export const removeFormField = action('REMOVE_FORM_FIELD')
export const updateForm = action('UPDATE_FORM')
export const clearForm = action('CLEAR_FORM')
export const setFormData = action('SET_FORM_DATA')
export const clearFormData = action('CLEAR_FORM_DATA')
export const removeAllForms = action('REMOVE_ALL_FORMS')

// Dynamic workflows
export const addDynamicWorkflow = action('ADD_DYNAMIC_WORKFLOW')
export const updateDynamicWorkflow = action('UPDATE_DYNAMIC_WORKFLOW')
export const removeDynamicWorkflow = action('REMOVE_DYNAMIC_WORKFLOW')
export const clearAllDynamicWorkflows = action('CLEAR_ALL_DYNAMIC_WORKFLOWS')

// Table
export const setPage = action('SET_PAGE')
export const setRowsPerPage = action('SET_ROWS_PER_PAGE')
export const sortBy = action('SORT_COLUMNS_BY')

// API
export const setAPI = action('SET_API')

// API
export const setNavigation = action('SET_NAVIGATION')

function action (action) {
  return ({dispatch}, ...args) => dispatch(action, ...args)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js